import { type GuardStatus, useSettings } from '@capsicum/common';
import { useMemo } from 'react';

/**
 * Check access on the old Topup if Poblano is enabled.
 * @returns {GuardStatus}
 */
export const useTopUpPoblanoGuardShared = (): {
	status: GuardStatus;
} => {
	const {
		areSettingsLoading,
		settings: { isPoblanoEnabled }
	} = useSettings();

	const getStatus = useMemo(() => {
		if (areSettingsLoading) return 'loading';
		if (isPoblanoEnabled) return 'denied';

		return 'allowed';
	}, [areSettingsLoading, isPoblanoEnabled]);

	return {
		status: getStatus
	};
};
